export default __webpack_public_path__ + "static/media/right-arrow.93b3bd63.svg";